import React from 'react'

// components
import Image from '/react4xp/components/Image'
import RichText from '../RichText'
import Section from '../Section'

export interface SimpleCard {
	image: string
	header: string
	text: string
	path: string
}

interface NavigationCardSectionProps {
	items?: SimpleCard[],
  title?: string,
  intro?: string,
  headingLevel?: 2 | 3 | 4 | 5 | 6,
}

export default function NavigationCardSection({
	items,
  title,
  intro,
  headingLevel = 2
}: NavigationCardSectionProps) {

  // a freely-placed section part cannot know its own depth, so the level is set
  // where the page is composed; 2 is right wherever the page title is the only h1
  const Heading = `h${headingLevel}` as const

  

	return (
    <Section className='navigation-card-section'>
      {title && <Heading className="title font-title">{title}</Heading>}
      {intro && <div className="intro"><RichText content={intro} /></div>}
      <div className='simple-card-grid'>
        {items && items.map((item) => (
          <a
            key={item.path}
            href={item.path}
            className='simple-card-grid__item'
          >
            <div className='simple-card-grid__image'>
              <Image
                src={item.image}
                alt={item.header}
                className='cover'
              />
            </div>

            <div className='simple-card-grid__content'>
              <h3 className='simple-card-grid__header'>
                {item.header}
              </h3>

              <p className='simple-card-grid__text'>
                {item.text}
              </p>
            </div>
          </a>
        ))}
      </div>
    </Section>
	)
}